import { render, staticRenderFns } from "./TransferInternalContent.vue?vue&type=template&id=198d78fc&lang=pug"
import script from "./TransferInternalContent.vue?vue&type=script&lang=js"
export * from "./TransferInternalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports